import React, { useEffect, useState, useRef } from 'react'
import useAuth from '../../auth/useAuth';

import { v4 as uuidv4 } from 'uuid';
import {
    settings, isUndNullEmpNew, getError, getLanguageObj, getResponse, LoadingSection, sendMessageCloseCurrentWindow,
    awaitDelay, getProcessButtons, getDtRowIndexNew
} from '../../helpers/UtilsHelper';
import { setRatesVariations, } from '../../helpers/rates/ratesHelper';

import Swal from 'sweetalert2';
import Menu from '../main/Menu';
import RateAddEdit from './RateAddEdit';
import { RateClass } from '../../classes/rate/rateClass';
import { UserClass } from '../../classes/user/userClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { UserService } from '../../services/users/UserService';
import { RateService } from '../../services/rates/RateService';
import TableIndex from '../main/TableIndex';

const $ = window?.$;

const { app, colors, firebase, html, icons, images, labels, messages, react, } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, operators: dbOperators, } = firebase?.firestore;
const { sweetAlert2, } = react;
const { urls } = app?.backend;

const currentMethod = 'Rates - function';

export default function Rates({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    // const selUsersId = 'selectUser';
    const selUsersIdRef = useRef(null);
    const isMount = useRef(true);
    const [process, setProcess] = useState({ showLoading: false, btnAdd: false });

    const [user, setUser] = useState({});
    const [users, setUsers] = useState([]);


    let dtRatesId = 'dtRates';
    const [rate, setRate] = useState(RateClass?.getClass());
    const [applyTo, setApplyTo] = useState(0);
    const [modalType, setModalType] = useState(0);
    const [showModal, setShowModal] = useState(false);
    //#endregion variables

    //#region methods
    const getUserAndRatesData = async ({
        e = {},
        userId = '',
        isSetUser = true,
        showMessage = true,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getUserAndRatesData';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            //#region variables
            let user_ = UserClass?.getClass();
            //#endregion variables

            //#region Datatable clear
            response = clearDataTable({ dtRates: true, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion Datatable clear

            if (isSetUser) setUser({});


            if (showMessage) {
                setProcess(prev => ({ ...prev, showLoading: true }));
            }

            userId = userId || selUsersIdRef?.current?.value;

            if (!isUndNullEmpNew({ data: userId, subMethod: currentMethod, })?.result) {
                if (isSetUser) {
                    user_ = users.filter(({ id }) => id === userId);
                    user_ = user_?.[0] || user_;
                    setUser(user_);
                }

                //#region get data (rates)
                response = await getRates({ user_: user_, subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;


                //#endregion get data (rates)
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (showMessage) {
                setProcess(prev => ({ ...prev, showLoading: false }));
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getRates = async ({
        user_ = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getRates';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let ratesDt = [];
            let rates_ = [RateClass?.getClass()];
            let dataObj = {};
            //#endregion variables

            //#region get data (rates)
            dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: user_?.id || selUsersIdRef?.current?.value, },
                ],
                ordersBy: [
                    { field: dbFields?.register, value: dbOrdersBy?.asc, },
                ],
            };
            response = await RateService.getAll({
                token: auth?.account?.tokenVzLaML?.token,
                dataObj: dataObj,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            rates_ = response?.result || [];
            //#endregion get data (rates)

            //#region set data (variations)
            if (!isUndNullEmpNew({ data: rates_, subMethod: currentMethod, })?.result &&
                rates_?.length > 0) {
                //#region Variations get
                response = setRatesVariations({
                    data: rates_,
                    // languageId: languageObj?.id,
                    languageObj: languageObj,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return response;

                rates_ = response?.result || [];
                //#endregion Variations get

                rates_.map((detail) => (
                    ratesDt.push([
                        detail?.[0],
                        detail?.[1],
                        getProcessButtons({
                            id: detail?.[3],
                            description: detail?.[4],
                            detailsShow: false,
                            detailsLabel: '',
                            detailsEnabled: false,
                            editShow: true,
                            editLabel: labels?.edit?.[languageObj?.id],
                            editEnabled: true,
                            deleteShow: true,
                            deleteLabel: labels?.delete?.[languageObj?.id],
                            deleteEnabled: true,
                            processButtons: [],
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        })?.result,
                        detail?.[2],
                    ])
                ));
            }
            //#endregion set data (variations)

            //#region set data (dataTable)
            $(`#${dtRatesId}`).DataTable().rows.add(ratesDt).draw(true);
            //#endregion set data (dataTable)
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getRateAddEditDelete = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getRateAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            //#region Previuos
            if (!isUndNullEmpNew({ data: e, subMethod: currentMethod, })?.result &&
                !isUndNullEmpNew({ data: e?.preventDefault, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion Previuos

            //#region variables
            let rate_ = RateClass?.getClass();
            //#endregion variables

            if (processType !== -1) {
                setProcess(prev => ({ ...prev, showLoading: true }));
            }

            //#region process
            setApplyTo(processType);
            setModalType(processType);
            // setShowModal(processType !== -1);

            switch (processType) {
                case 0:
                    rate_.id = uuidv4();
                    rate_.userId = user?.id;
                    setRate(rate_);
                    await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
                    break;
                case 1:
                    //#region get data (rate)
                    response = await getRateById({
                        id: id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) return;

                    rate_ = response.result;
                    //#endregion get data (rate)
                    setRate(rate_);
                    break;
                case -1:
                    //#region show message
                    let msgTextObj = {
                        one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        two: `${labels?.rate?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    let swalProperties = SwalPropertiesClass?.getClass();
                    swalProperties = {
                        icon: sweetAlert2?.icons?.warning,
                        title: msgTextObj?.one,
                        html: `${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        customClass: {
                            popup: html?.popup,
                            confirmButton: html?.buttons?.primary,
                            cancelButton: html?.buttons?.secondary,
                        },
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: () => !Swal?.isLoading(),
                        preConfirm: async () => {
                            let preConfirmResponse = getResponse({ type: 0 });
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal.update({
                                    icon: sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}`,
                                    html: `${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                //#region delete data (rate)
                                preConfirmResponse = await RateService.deleteById({
                                    id: id,
                                    token: auth?.account?.tokenVzLaML?.token,
                                    subMethod: currentMethod
                                });
                                if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                                await getUserAndRatesData({
                                    e: null,
                                    userId: user?.id || selUsersIdRef?.current?.value,
                                    isSetUser: false,
                                    showMessage: false,
                                    subMethod: currentMethod,
                                });

                                preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                                //#endregion delete data (rate)
                            } catch (ex) {
                                preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                            }
                            return preConfirmResponse;
                        }
                    };

                    const swalresult = await Swal.fire({ ...swalProperties });
                    if (swalresult?.isConfirmed && swalresult?.value) {
                        response = swalresult?.value;
                    } else if (swalresult?.isDismissed) {
                        response = getResponse({ type: 0 });
                    }
                    //#endregion show message
                    break;
                default:
                    break;
            }
            //#endregion process

            if (processType !== -1) setShowModal(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            if (processType !== -1) {
                setProcess(prev => ({ ...prev, showLoading: false }));
            }
            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getRateById = async ({
        id = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getRateById';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            //#region get data (rate)
            response = await RateService.getById({
                id: id,
                token: auth?.account?.tokenVzLaML?.token,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;
            //#endregion get data (rate)
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion methods

    //#region methods (others)
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let dataObj = {};
            //#endregion variables

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region dataTable set
            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion dataTable set

            //#region set queryCode
            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set queryCode

            //#region get data (users)
            dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: auth?.account?.uid, },
                ],
                ordersBy: [
                    { field: dbFields?.userName, value: dbOrdersBy?.asc, },
                ],
            };

            response = await UserService.getUsers({
                token: auth?.account?.tokenVzLaML?.token,
                data: dataObj,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setUsers(response?.result || []);
            //#endregion get data (users)
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDataTable = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtRatesId}`).DataTable({
                destroy: true,
                data: [],
                order: [[3, 'desc']],
                columns: [
                    { title: labels?.rate?.[languageObj?.id], width: '50%', orderable: false, },
                    { title: labels?.registry?.[languageObj?.id], width: '45%', orderable: false, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, searchable: false },
                    { title: labels?.registry?.[languageObj?.id], width: '0%', orderable: false, searchable: false, visible: false, },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtRatesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const clearDataTable = ({
        dtRates = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'clearDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            if (dtRates) $(`#${dtRatesId}`).DataTable().rows().remove().draw(true);
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let methodName = '';
            let description = '';
            //#endregion variables

            //#region process
            $(`#${dtRatesId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndexNew({ dtId: dtRatesId, this_: this, subMethod: currentMethod })?.result;
                if (!isUndNullEmpNew({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getRateAddEditDelete({
                                e: e,
                                id: id,
                                description: description,
                                rowIndex: rowIndex,
                                processType: 1,
                                subMethod: currentMethod
                            });
                            break;
                        case 'delete':
                            getRateAddEditDelete({
                                e: e,
                                id: id,
                                description: description,
                                rowIndex: rowIndex,
                                processType: -1,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName={'rates'} process={'rates'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.rates?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home} className='link-primary-bold'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.rates?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}


                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.account?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.info} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.account?.[languageObj?.id]}</h5>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body pt-0'>

                                        <div className='row'>
                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {messages?.selectUser?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <select className='form-control border-0 shadow-sm form-input-icon custom-select'
                                                            ref={selUsersIdRef}
                                                            onChange={(e) => getUserAndRatesData({ e: e, userId: e?.target?.value, showMessage: true, subMethod: 'selUser', })}>
                                                            <option id='nothing' defaultValue value=''>{messages?.selectUser?.[languageObj?.id]}</option>
                                                            {users?.length > 0 ?
                                                                users.map((detail) => (
                                                                    <option key={detail?.id} value={detail?.id}>{detail?.userName}</option>
                                                                ))
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.firstName?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            placeholder={labels?.firstName?.[languageObj?.id]}
                                                            value={user?.firstName || ''}
                                                            title={labels?.firstName?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.lastName?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.idCard} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            placeholder={labels?.lastName?.[languageObj?.id]}
                                                            value={user?.lastName || ''}
                                                            title={labels?.lastName?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div className={settings?.html?.cards?.default}>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.rates?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.forex} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.rates?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body pt-0'>
                                        <div className='d-flex flex-wrap justify-content-end align-items-center mb-3' style={{ gap: '8px' }}>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading || !user?.id}
                                                data-title={labels?.addNewRate?.[languageObj?.id]}
                                                onClick={(e) => getRateAddEditDelete({ e: e, id: '', description: '', rowIndex: 0, processType: 0, subMethod: 'btnRateAdd', })}>
                                                <i className={`${icons?.fasFa?.plusCircle} mr-1`}></i> {labels?.add?.[languageObj?.id] || 'Add'}
                                            </button>
                                        </div>
                                        <TableIndex tableId={dtRatesId} languageObj={languageObj} />
                                        {/* <div className='table-responsive-sm'>
                                            <table id={dtRatesId} className={settings?.dataTables?.formats?.smStripedBordered}></table>
                                        </div> */}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {showModal && (
                        <RateAddEdit processValues={{
                            $,
                            auth,
                            user,
                            setUser,
                            users,
                            setUsers,
                            rate,
                            setRate,
                            applyTo,
                            setApplyTo,
                            // rateAddEditDateTimeId,
                            // modalId,
                            showModal,
                            setShowModal,
                            type: modalType,
                            setType: setModalType,
                            getUserAndRatesData: getUserAndRatesData,
                            formName: 'Rates',
                        }} />
                    )}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}